(function () {
  'use strict';
  var doc = document.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(pointer: fine)').matches;
  if (!reduce) doc.classList.add('vp-motion');

  function ready(fn) { document.readyState !== 'loading' ? fn() : document.addEventListener('DOMContentLoaded', fn); }

  ready(function () {
    var announce = document.querySelector('.vp-announce');
    function setAh() { doc.style.setProperty('--vp-ah', (announce ? announce.offsetHeight : 0) + 'px'); }
    setAh();
    window.addEventListener('resize', setAh, { passive: true });

    var lenis = null;
    if (!reduce && fine && window.Lenis) {
      lenis = new window.Lenis({ duration: 1.1, easing: function (t) { return Math.min(1, 1.001 - Math.pow(2, -10 * t)); }, smoothWheel: true });
      (function raf(time) { lenis.raf(time); requestAnimationFrame(raf); })(performance.now());
    }

    var menu = document.querySelector('.vp-menu');
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href*="#"]');
      if (!a) return;
      var url = new URL(a.href, location.href);
      if (url.pathname !== location.pathname || url.hash.length < 2) return;
      var el = document.getElementById(url.hash.slice(1));
      if (!el) return;
      e.preventDefault();
      if (menu) menu.open = false;
      var head = document.querySelector('.vp-header');
      var off = head ? head.offsetHeight + 12 : 80;
      var target = Math.max(0, el.getBoundingClientRect().top + window.scrollY - off);
      if (lenis) lenis.scrollTo(target);
      else window.scrollTo({ top: target, behavior: reduce ? 'auto' : 'smooth' });
      history.replaceState(null, '', url.hash);
    });
    if (menu) {
      menu.querySelectorAll('.vp-menu__panel a').forEach(function (a) { a.addEventListener('click', function () { menu.open = false; }); });
      document.addEventListener('click', function (e) { if (menu.open && !menu.contains(e.target)) menu.open = false; });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') menu.open = false; });
    }

    var header = document.querySelector('.vp-header');
    var bar = document.querySelector('.vp-progress');
    var sticky = document.querySelector('.vp-sticky');
    var stickyStop = document.querySelector('[data-vp-sticky-stop]');
    var parallax = reduce ? [] : [].slice.call(document.querySelectorAll('[data-vp-parallax]'));
    var ticking = false;
    function frame() {
      ticking = false;
      var y = window.scrollY;
      var max = doc.scrollHeight - window.innerHeight;
      if (header) header.classList.toggle('is-scrolled', y > 12);
      if (bar) bar.style.transform = 'scaleX(' + (max > 0 ? Math.min(1, y / max) : 0) + ')';
      if (sticky) {
        var past = y > window.innerHeight * 0.85;
        var nearEnd = stickyStop && stickyStop.getBoundingClientRect().top < window.innerHeight;
        sticky.classList.toggle('is-active', past && !nearEnd);
      }
      parallax.forEach(function (el) {
        var r = el.parentElement.getBoundingClientRect();
        if (r.bottom < 0 || r.top > window.innerHeight) return;
        var speed = parseFloat(el.getAttribute('data-vp-parallax')) || 0.06;
        var off = (r.top + r.height / 2 - window.innerHeight / 2) * -speed;
        el.style.transform = 'translate3d(0,' + off.toFixed(1) + 'px,0)';
      });
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }
    frame();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });

    var items = [].slice.call(document.querySelectorAll('[data-vp-reveal]'));
    if (reduce || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-revealed'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-revealed');
          io.unobserve(entry.target);
        });
      }, { threshold: 0.1, rootMargin: '0px 0px -6% 0px' });
      items.forEach(function (el) {
        var group = [].slice.call(el.parentElement.children).filter(function (c) { return c.hasAttribute('data-vp-reveal'); });
        var i = group.indexOf(el);
        if (i > 0) el.style.transitionDelay = Math.min(i * 70, 350) + 'ms';
        io.observe(el);
      });
    }

    var canvas = document.querySelector('[data-vp-snow]');
    if (canvas && !reduce && canvas.getContext) {
      var ctx = canvas.getContext('2d');
      var flakes = [], W = 0, H = 0, dpr = Math.min(window.devicePixelRatio || 1, 2), running = true;
      function size() {
        W = canvas.clientWidth; H = canvas.clientHeight;
        canvas.width = W * dpr; canvas.height = H * dpr;
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        var n = Math.round(Math.min(90, W / 14));
        flakes = [];
        for (var i = 0; i < n; i++) flakes.push({ x: Math.random() * W, y: Math.random() * H, r: Math.random() * 1.8 + .5, s: Math.random() * .45 + .15, d: Math.random() * Math.PI * 2, a: Math.random() * .45 + .25 });
      }
      size();
      window.addEventListener('resize', size, { passive: true });
      if ('IntersectionObserver' in window) new IntersectionObserver(function (e) { running = e[0].isIntersecting; if (running) requestAnimationFrame(tick); }).observe(canvas);
      function tick() {
        if (!running || document.hidden) return;
        ctx.clearRect(0, 0, W, H);
        for (var i = 0; i < flakes.length; i++) {
          var f = flakes[i];
          f.d += .01; f.y += f.s; f.x += Math.sin(f.d) * .3;
          if (f.y > H + 4) { f.y = -4; f.x = Math.random() * W; }
          ctx.beginPath(); ctx.arc(f.x, f.y, f.r, 0, Math.PI * 2);
          ctx.fillStyle = 'rgba(248,238,220,' + f.a + ')'; ctx.fill();
        }
        requestAnimationFrame(tick);
      }
      document.addEventListener('visibilitychange', function () { if (!document.hidden && running) requestAnimationFrame(tick); });
      requestAnimationFrame(tick);
    }

    var visual = document.querySelector('[data-vp-tilt]');
    if (visual && fine && !reduce) {
      visual.addEventListener('mousemove', function (e) {
        var r = visual.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5, yy = (e.clientY - r.top) / r.height - 0.5;
        visual.style.transform = 'perspective(1400px) rotateY(' + (x * 4).toFixed(2) + 'deg) rotateX(' + (-yy * 4).toFixed(2) + 'deg)';
      });
      visual.addEventListener('mouseleave', function () {
        visual.style.transition = 'transform .8s cubic-bezier(.16,1,.3,1)';
        visual.style.transform = '';
        setTimeout(function () { visual.style.transition = ''; }, 800);
      });
    }

    var faqs = document.querySelectorAll('.vp-faq details');
    faqs.forEach(function (d) { d.addEventListener('toggle', function () { if (d.open) faqs.forEach(function (o) { if (o !== d) o.open = false; }); }); });

    var toast = document.createElement('div');
    toast.className = 'vp-toast';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    document.body.appendChild(toast);
    function showToast(img, title, going) {
      toast.innerHTML = (img ? '<img src="' + img + '" alt="">' : '') + '<div><b>✓ Añadido al carrito</b><span>' + title + '</span></div>' + (going ? '<span class="vp-toast__go" style="margin-left:6px;color:#e6c07a;font-size:13px;font-weight:600;white-space:nowrap">Abriendo pago…</span>' : '<a class="vp-btn" href="/checkout">Pagar</a>');
      toast.classList.add('is-visible');
      clearTimeout(showToast.t);
      showToast.t = setTimeout(function () { toast.classList.remove('is-visible'); }, 4500);
    }
    function cartIcon() {
      var icons = document.querySelectorAll('[data-vp-cart]');
      for (var i = 0; i < icons.length; i++) if (icons[i].offsetParent) return icons[i];
      return icons[0];
    }
    function bumpCart(count) {
      var icon = cartIcon();
      if (!icon) return;
      var badge = icon.querySelector('.vp-icon__count');
      if (!badge) { badge = document.createElement('span'); badge.className = 'vp-icon__count'; icon.appendChild(badge); }
      badge.textContent = count;
      icon.setAttribute('aria-label', 'Carrito (' + count + ')');
      icon.classList.remove('is-pulse'); void icon.offsetWidth; icon.classList.add('is-pulse');
    }
    function burst(x, y) {
      var colors = ['#e6c07a', '#56c88a', '#ff7a6b', '#f5eee2'];
      for (var i = 0; i < 10; i++) {
        var p = document.createElement('span');
        p.className = 'vp-burst';
        p.style.background = colors[i % 4];
        p.style.left = x + 'px'; p.style.top = y + 'px';
        document.body.appendChild(p);
        var ang = (Math.PI * 2 * i) / 10, dist = 22 + Math.random() * 14;
        p.animate([{ transform: 'translate(-50%,-50%) scale(1)', opacity: 1 }, { transform: 'translate(' + (Math.cos(ang) * dist - 3) + 'px,' + (Math.sin(ang) * dist - 3) + 'px) scale(.3)', opacity: 0 }], { duration: 600, easing: 'cubic-bezier(.16,1,.3,1)' }).onfinish = (function (el) { return function () { el.remove(); }; })(p);
      }
    }
    function fly(fromEl, img) {
      return new Promise(function (resolve) {
        var icon = cartIcon();
        if (!fromEl || !icon || !Element.prototype.animate) return resolve();
        var a = fromEl.getBoundingClientRect(), b = icon.getBoundingClientRect();
        var dot = document.createElement('div');
        dot.className = 'vp-fly';
        if (img) dot.style.backgroundImage = 'url("' + img + '")';
        document.body.appendChild(dot);
        var x0 = a.left + a.width / 2 - 32, y0 = a.top + a.height / 2 - 32;
        var x1 = b.left + b.width / 2 - 32, y1 = b.top + b.height / 2 - 32;
        var mx = (x0 + x1) / 2, my = Math.min(y0, y1) - 120;
        dot.animate([
          { transform: 'translate(' + x0 + 'px,' + y0 + 'px) scale(.6)', opacity: 0 },
          { transform: 'translate(' + x0 + 'px,' + y0 + 'px) scale(1)', opacity: 1, offset: .15 },
          { transform: 'translate(' + mx + 'px,' + my + 'px) scale(.8)', opacity: 1, offset: .55 },
          { transform: 'translate(' + x1 + 'px,' + y1 + 'px) scale(.22)', opacity: .9 }
        ], { duration: reduce ? 450 : 900, easing: 'cubic-bezier(.45,0,.2,1)' }).onfinish = function () {
          dot.remove();
          burst(b.left + b.width / 2, b.top + b.height / 2);
          resolve();
        };
      });
    }

    function productImg(form) {
      var holder = form.closest('[data-vp-product]');
      if (holder && holder.getAttribute('data-vp-img')) return holder.getAttribute('data-vp-img');
      var scope = form.closest('article, .vicio-product__grid, .vicio-product-card, section') || document;
      var im = scope.querySelector('img');
      return im ? (im.currentSrc || im.src) : '';
    }
    function productTitle(form) {
      var holder = form.closest('[data-vp-product]');
      if (holder && holder.getAttribute('data-vp-title')) return holder.getAttribute('data-vp-title');
      var scope = form.closest('article, .vicio-product__summary, .vicio-product-card, section') || document;
      var h = scope.querySelector('h1, h2, h3');
      return h ? h.textContent.trim() : 'Producto';
    }
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.matches || !form.matches('form[data-vp-buy], form[data-vicio-buy]')) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      if (form.dataset.vpBusy) return;
      form.dataset.vpBusy = '1';
      var mode = form.getAttribute('data-vp-buy') || 'checkout';
      var btn = form.querySelector('button[type="submit"], button:not([type])');
      var original = btn ? btn.innerHTML : '';
      var img = productImg(form), title = productTitle(form);
      if (btn) { btn.disabled = true; btn.innerHTML = 'Añadiendo…'; }

      fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
        .then(function (r) { if (!r.ok) throw new Error('cart'); return fetch('/cart.js', { headers: { Accept: 'application/json' } }); })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          return fly(btn || form, img).then(function () {
            bumpCart(cart.item_count);
            if (btn) { btn.classList.add('is-added'); btn.innerHTML = mode === 'checkout' ? '✓ Añadido' : '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="m5 12 5 5 9-10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'; }
            if (mode === 'checkout') {
              showToast(img, title, true);
              setTimeout(function () { window.location.href = '/checkout'; }, 1100);
              return;
            }
            showToast(img, title, false);
            setTimeout(function () { delete form.dataset.vpBusy; if (btn) { btn.disabled = false; btn.classList.remove('is-added'); btn.innerHTML = original; } }, 2200);
          });
        })
        .catch(function () { delete form.dataset.vpBusy; if (btn) { btn.disabled = false; btn.innerHTML = original; } HTMLFormElement.prototype.submit.call(form); });
    }, true);

    var pop = document.getElementById('vpPop');
    if (pop) {
      var KEY = 'vp_pop_seen', seen = false, armed = false;
      try { seen = !!sessionStorage.getItem(KEY); } catch (err) {}
      setTimeout(function () { armed = true; }, 12000);
      var show = function () {
        if (seen || !armed) return;
        seen = true;
        try { sessionStorage.setItem(KEY, '1'); } catch (err) {}
        pop.hidden = false;
        if (lenis) lenis.stop();
        requestAnimationFrame(function () { requestAnimationFrame(function () { pop.classList.add('is-visible'); }); });
        var x = pop.querySelector('.vp-pop__x');
        if (x) x.focus({ preventScroll: true });
      };
      var hide = function () {
        pop.classList.remove('is-visible');
        if (lenis) lenis.start();
        setTimeout(function () { pop.hidden = true; }, 350);
      };
      pop.querySelectorAll('[data-vp-close]').forEach(function (b) { b.addEventListener('click', hide); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !pop.hidden) hide(); });
      if (fine) document.addEventListener('mouseout', function (e) { if (!e.relatedTarget && e.clientY < 8) show(); });
      else window.addEventListener('scroll', function () { var max = doc.scrollHeight - window.innerHeight; if (max > 0 && window.scrollY / max > 0.6) show(); }, { passive: true });
    }
  });
})();
